module.exports = __webpack_public_path__ + "static/media/container-002.5f15f727.jpg";